export enum PredefinedDateRangeType {
  ThreeMonths = "Three Months",
  SixMonths = "Six Months",
  OneYear = "One Year",
  CurrentYear = "Current Year",
  PreviousYear = "Previous Year",
  AllDates = "All Dates",
}
